import { createStyles, makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { IconButton } from "@material-ui/core";

import { RelodeTheme, Text } from "..";
import { ChevronLeftIcon, ChevronRightIcon } from "../../assets/icons";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            navigation: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(2),
            },
            navText: {
                whiteSpace: "nowrap",
                width: "40%",
                textAlign: "center",
            },
            iconButton: {
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: 24,
                "&:disabled": {
                    border: "1px solid #cccccc",
                },
            },
        }),
    { name: "PaginatorMobile" }
);

interface Props {
    baseId?: string;
    range?: { start: number; end: number };
    current?: number;
    total?: number;
    showAsRange?: boolean;
    navigate: (direction: "next" | "prev") => void;
    isBusy?: boolean;
    entityName?: string;
}

export const PaginatorMobile = (props: Props) => {
    const {
        baseId,
        navigate,
        total = 0,
        showAsRange = false,
        current = 0,
        range = { start: 0, end: 0 },
        isBusy,
        entityName,
    } = props;

    const classes = useStyles({});
    const extendedId = `${baseId}Paginator`;

    const navText = showAsRange
        ? `${range.start} - ${range.end} of ${total}`
        : `${current} of ${total}`;

    const prevDisabled = isBusy
        ? isBusy
        : showAsRange
        ? range.start === 1
        : current === 1;

    const nextDisabled = isBusy
        ? isBusy
        : showAsRange
        ? range.end === total
        : current === total;

    return (
        <div className={classes.navigation} id={`${extendedId}Wrapper`}>
            <IconButton
                id={`${extendedId}PrevButton`}
                className={classes.iconButton}
                title={`previous ${entityName || ""}`}
                color="primary"
                disabled={prevDisabled}
                onClick={() => navigate("prev")}
            >
                <ChevronLeftIcon />
            </IconButton>
            <Text className={classes.navText} variant="body1" color="primary">
                {navText}
            </Text>
            <IconButton
                id={`${extendedId}NextButton`}
                className={classes.iconButton}
                title={`next ${entityName || ""}`}
                color="primary"
                disabled={nextDisabled}
                onClick={() => navigate("next")}
            >
                <ChevronRightIcon />
            </IconButton>
        </div>
    );
};
